
import dayjs from 'dayjs';

function getOldDate(day){

  const currentSeconds = dayjs().unix();
  const seconds = day * 86400;

  const diff = currentSeconds - seconds;
  return dayjs.unix(diff).format('YYYY-MM-DDTHH:mm:ss');
};

const disable12MonthsDate = (current, { from }) => {
  if (from) {
    const curMonth = current.year() * 12 + current.month();
    const fromMonth = from.year() * 12 + from.month();
    return Math.abs(fromMonth - curMonth) >= 12;
  }
  return false;
};

const dateHourFormatIta = "DD/MM/YYYY HH:mm:ss";
const dateHourFormat    = "YYYY/MM/DD HH:mm:ss";
const dateEnFormat      = "YYYY/MM/DD";
const hourFormatIta     = "HH:mm";

var todayStartDate  = dayjs().format('YYYY-MM-DDT00:00:00');
var todayEndDate    = dayjs().format('YYYY-MM-DDT23:59:59');
var nowDateTimeIta  = dayjs().format(dateHourFormatIta);
var nowDateEn       = dayjs().format(dateEnFormat);
var nowTime         = dayjs().format(hourFormatIta);
var startToday      = dayjs().startOf('day');
var endToday        = dayjs().endOf('day');

var rangeYesterday = [dayjs().add(-1, 'd').startOf("day"), dayjs().add(-1, 'd').endOf("day")];
var rangeLastMonth = [dayjs().add(-30, 'd'), dayjs()];
var rangeLast7Days = [dayjs().add(-7, 'd'), dayjs()];


const daysOfWeek = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
  
const monthsOfYear = [
"Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
"Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

const weeksOfMonth = ['Prima', 'Seconda', 'Terza', 'Quarta', 'Ultima'];
   

//presets per tutti i calendari
  const rangePresets = [
    {
      label: 'Oggi',
      value: [dayjs().add(0, 'd').startOf("day"), dayjs().add(0, 'd').endOf("day")],
    },
    {
      label: 'Ieri',
      value: [dayjs().add(-1, 'd').startOf("day"), dayjs().add(-1, 'd').endOf("day")],
    },
    {
      label: 'Ultimi 7 giorni',
      value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
      label: 'Ultimi 14 giorni',
      value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
      label: 'Ultimi 30 giorni',
      value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
      label: 'Ultimi 90 giorni',
      value: [dayjs().add(-90, 'd'), dayjs()],
    },
  ];

  const rangePresetsFuture = [
    {
      label: 'Domani',
      value: [dayjs().add(+1, 'd').startOf("day"), dayjs().add(-1, 'd').endOf("day")],
    },
    {
      label: 'Tra 7 giorni',
      value: [dayjs().add(+7, 'd'), dayjs()],
    },
    {
      label: 'Tra 14 giorni',
      value: [dayjs().add(+14, 'd'), dayjs()],
    },
    {
      label: 'Tra 30 giorni',
      value: [dayjs().add(+30, 'd'), dayjs()],
    },
    {
      label: 'Tra 90 giorni',
      value: [dayjs().add(+90, 'd'), dayjs()],
    },
    {
      label: 'Tra 10 anni',
      value: [dayjs().add(+10, 'y'), dayjs()],
    },
  ];


                  /////////////////////////////////////////////////////////////////////////////////////////// 
//////////////////// questa funzione mi converte tutti gli array di data inizio e fine in un oggetto day js ///////////////
                  /////////////////////////////////////////////////////////////////////////////////////////// 
 
function convertFullDateToDayjs(obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => convertFullDateToDayjs(item));
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      if (key === 'full_date' && Array.isArray(obj[key]) && obj[key].length === 2) {
        acc[key] = obj[key].map(date => dayjs(date)); // Converte ogni data in oggetto dayjs
      } else {
        acc[key] = convertFullDateToDayjs(obj[key]); // Ricorsione sugli altri campi
      }
      return acc;
    }, {});
  }
  return obj;
}

                  /////////////////////////////////////////////////////////////////////////////////////////// 
//////////////////// questa funzione mi converte tutti gli array di data inizio e fine in un oggetto day js ///////////////
                  ///////////////////////////////////////////////////////////////////////////////////////////
 
 ///////////////////////////////////////////////////////////////////////////////////////////
         //////////////////// funzione che ritorna i giorni successivi ///////////////
 ///////////////////////////////////////////////////////////////////////////////////////////
 
function nowPlusDays(numberOfDays) {
  if (!numberOfDays) return "";
  return dayjs().add(+numberOfDays, 'd').format(dateHourFormatIta);
}
 
 /////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// funzione che ritorna i giorni successivi /////////////// 
 /////////////////////////////////////////////////////////////////////////////////////////// 


export {
  
  monthsOfYear,
  weeksOfMonth,
  daysOfWeek,

  dateHourFormatIta,
  nowDateTimeIta,
  dateHourFormat,
  todayStartDate,
  todayEndDate,
  rangePresets,
  dateEnFormat,
  startToday,
  nowDateEn,
  endToday,
  nowTime,

  rangePresetsFuture,
  rangeYesterday,
  rangeLast7Days,
  rangeLastMonth,
  
  convertFullDateToDayjs,
  disable12MonthsDate,
  nowPlusDays,
  getOldDate,
}